/**
 * 系统管理  系统环境变量
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员配置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.varLable" placeholder="输入变量描述"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.varName" placeholder="输入变量名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="vipId" label="编号" min-width="50">
      </el-table-column>
      <el-table-column prop="vipDescription" label="会员描述" min-width="50">
      </el-table-column>
      <el-table-column prop="vipMonth" label="会员时长(月)" min-width="50">
      </el-table-column>
      <el-table-column prop="vipPrice" label="会员价格(分)" min-width="50">
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-form-item label="会员描述" prop="vipDescription">
          <el-input size="small" v-model="editForm.vipDescription" auto-complete="off" placeholder="变量描述"></el-input>
        </el-form-item>
        <el-form-item label="会员时长(月)" prop="vipMonth">
          <el-input size="small" v-model="editForm.vipMonth" auto-complete="off" placeholder="变量名称"></el-input>
        </el-form-item>
        <el-form-item label="会员价格(分)" prop="vipPrice">
          <el-input size="small" v-model="editForm.vipPrice" auto-complete="off" placeholder="变量名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm(title)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import{
  vipConfigList,
  updateVipConfig,
  addVipConfig
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        vipId: '',
        vipDescription: '',
        vipMonth: '',
        vipPrice: ''
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.pageparm)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      // 获取用户列表
      vipConfigList(parameter).then(res => {
        this.loading = false
        if (res.code == '00051') {
          this.listData = res.data.list
          // 分页赋值
          this.formInline.page = this.pageparm.pageIndex
          this.formInline.limit = this.pageparm.pageSize
          this.pageparm.total = res.data.total
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageIndex = parm.pageIndex
      this.pageparm.pageSize = parm.pageSize
      this.getdata(this.pageparm)
    },
    // 搜索事件
    search() {
      this.getdata(this.pageparm)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '编辑'
        this.editForm.vipId = row.vipId
        this.editForm.vipDescription = row.vipDescription
        this.editForm.vipMonth = row.vipMonth
        this.editForm.vipPrice = row.vipPrice
      } else {
        this.title = '添加'
        this.editForm.vipId = ''
        this.editForm.vipDescription = ''
        this.editForm.vipMonth = ''
        this.editForm.vipPrice = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if(editData == '编辑') {
        updateVipConfig(this.editForm)
          .then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == '00071') {
              this.getdata(this.pageparm)
              this.$message({
                type: 'success',
                message: '编辑成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
      }else if(editData == '添加'){
        addVipConfig(this.editForm)
        .then(res=>{
          this.editFormVisible = false
          this.loading = false
          if (res.code == '00061') {
            this.getdata(this.pageparm)
            this.$message({
              type: 'success',
              message: '添加成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      }

    },
    // 删除权限
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          variableDelete(row.varId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '系统环境变量已删除'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统环境变量删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/VipConfig.vue